import React, { useState } from "react";
import "./HTML_MAIN_CSS.css";

const HTML_InterviewPrep = () => {
  const faqs = [
    {
      question: "What is HTML?",
      answer:
        "HTML (HyperText Markup Language) is the standard markup language for creating web pages. It provides the structure of the page using elements like headings, paragraphs, links, and images. " +
        "Explanation: HTML defines the skeleton of a webpage, allowing browsers to render content in an organized way.",
    },
    {
      question: "What is the difference between HTML and XHTML?",
      answer:
        "HTML is more lenient with syntax, while XHTML is stricter, following XML rules. XHTML requires all tags to be properly closed and nested. " +
        "Explanation: XHTML enforces well-formed markup, which improves interoperability and consistency but requires developers to follow stricter rules.",
    },
    {
      question: "What are semantic elements in HTML?",
      answer:
        "Semantic elements clearly describe their meaning and purpose. Examples include <header>, <footer>, <article>, <section>, <nav>, <aside>. " +
        "Explanation: Using semantic tags improves accessibility, SEO, and code readability by providing meaningful structure to web pages.",
    },
    {
      question: "Difference between <div> and <span>?",
      answer:
        "<div> is block-level and used to group elements; <span> is inline and used to style or manipulate a portion of text. " +
        "Explanation: Block elements take full width, starting on a new line; inline elements flow within text and only occupy the space they need.",
    },
    {
      question: "What is <!DOCTYPE html>?",
      answer:
        "It declares the document type and HTML version. In HTML5, it's <!DOCTYPE html>. " +
        "Explanation: This ensures the browser renders the page in standards mode rather than quirks mode, preventing rendering inconsistencies.",
    },
    {
      question: "What are data attributes in HTML?",
      answer:
        "Data attributes store extra information on HTML elements using data-* format. Example: <div data-user='123'>. " +
        "Explanation: These attributes allow developers to store custom data without affecting the presentation, accessible via JavaScript.",
    },
    {
      question: "Difference between <b> and <strong>?",
      answer:
        "<b> is purely presentational (bold text), while <strong> is semantic, indicating importance. " +
        "Explanation: <strong> helps screen readers and SEO understand which content is significant, unlike <b>.",
    },
    {
      question: "Different types of lists in HTML?",
      answer:
        "Ordered lists (<ol>), unordered lists (<ul>), and definition lists (<dl> with <dt> and <dd>). " +
        "Explanation: Lists organize information systematically, and each type conveys different meaning (sequence vs unordered items vs definitions).",
    },
    {
      question: "How to embed a video in HTML?",
      answer:
        "Use <video> tag with attributes like src, controls, autoplay. Example: <video src='video.mp4' controls></video>. " +
        "Explanation: This allows native playback in browsers without plugins, with controls for user interaction.",
    },
    {
      question: "Inline, block, inline-block differences?",
      answer:
        "Block elements take full width (<div>), inline elements flow in text (<span>), inline-block combines inline flow with block sizing (<img>). " +
        "Explanation: Understanding this helps in designing layout and spacing effectively using CSS.",
    },
    {
      question: "Forms in HTML?",
      answer:
        "<form> element collects user input with <input>, <textarea>, <select>, <button>. Attributes like action and method define submission. " +
        "Explanation: Forms are the primary method for users to interact with web apps, sending data to the server or JavaScript.",
    },
    {
      question: "Difference between <iframe> and <embed>?",
      answer:
        "<iframe> embeds another HTML page; <embed> embeds media like PDFs, Flash, or external content. " +
        "Explanation: <iframe> is often used for content like videos or widgets, while <embed> handles general external resources.",
    },
    {
      question: "What are HTML entities?",
      answer:
        "Special characters in HTML, e.g., &lt; for '<', &gt; for '>', &amp; for '&', &copy; for ©. " +
        "Explanation: Entities allow reserved characters to be displayed correctly without breaking HTML syntax.",
    },
    {
      question: "Global attributes in HTML?",
      answer:
        "Attributes that can be applied to any HTML element: id, class, style, title, hidden, data-*. " +
        "Explanation: These provide consistent control and styling across all elements.",
    },
    {
      question: "Difference between <section> and <article>?",
      answer:
        "<section> is a thematic grouping; <article> is self-contained content like a blog post. " +
        "Explanation: Semantic meaning improves readability, SEO, and accessibility.",
    },
    {
      question: "How to make a website responsive?",
      answer:
        "Use <meta name='viewport'>, semantic HTML, CSS media queries. " +
        "Explanation: Ensures the layout adapts to various screen sizes for better UX across devices.",
    },
    {
      question: "Differences between HTML and HTML5?",
      answer:
        "HTML5 introduced semantic tags, multimedia support (<video>, <audio>), APIs (Canvas, Storage), and improved accessibility. " +
        "Explanation: HTML5 is modern, cross-browser compatible, and provides richer functionality without plugins.",
    },
    {
      question: "Differences between localStorage, sessionStorage, and cookies?",
      answer:
        "localStorage: permanent data; sessionStorage: session-only; cookies: small data sent to server. " +
        "Explanation: Choose based on data persistence, scope, and server communication needs.",
    },
    {
      question: "Improving accessibility in HTML?",
      answer:
        "Use semantic tags, alt text, ARIA roles, label inputs, proper contrast, logical structure. " +
        "Explanation: Accessibility ensures all users, including those with disabilities, can interact with your website.",
    },
    {
      question: "Explain the <canvas> element.",
      answer:
        "<canvas> is used for drawing graphics via JavaScript. " +
        "Explanation: Useful for animations, games, charts, and dynamic visuals directly in the browser.",
    },
    {
      question: "What is the purpose of <picture> element?",
      answer:
        "Allows serving different images for different screen sizes or resolutions. " +
        "Explanation: Helps in responsive design by using <source> elements with media queries.",
    },
    {
      question: "Explain Web Storage API in HTML5.",
      answer:
        "localStorage and sessionStorage allow storing key-value pairs in the browser. " +
        "Explanation: This helps maintain state, preferences, or temporary data without server communication.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="interview-container">
      <h1>HTML Interview Preparation Questions & Answers</h1>
      {faqs.map((faq, idx) => (
        <div key={idx} className="faq-item">
          <h3
            className="faq-question"
            onClick={() => toggleFAQ(idx)}
            style={{ cursor: "pointer" }}
          >
            {faq.question}
          </h3>
          {openIndex === idx && (
            <div className="faq-answer-box">
              <p className="faq-answer">{faq.answer}</p>
            </div>
          )}
          <hr className="divider" />
        </div>
      ))}
    </div>
  );
};

export default HTML_InterviewPrep;
